<template>
  <v-main>
    <v-container class="pa-4" id="about-main-content">
      <v-row align="center" class="pa-4" justify="center">
        <section class="mt-4" style="max-width: 1000px; margin-top: 100px;">
          <h1 class="text-h3">Om Seriekart</h1>
          <p class="pa-1" v-text="aboutText" />
          <p>
            Seriekart er et verktøy fra NVE som hjelper deg å finne hydrologiske
            tidsserier som egner seg for bruk i analyser og lignende. Løsningen
            lar deg filtrere tidsserier basert på en rekke ulike egenskaper. Du
            kan også eksportere ut metadata og døgnverdier for tidsseriene.
          </p>

          <p>
            Verktøyet er tilgjengelig for alle og inneholder
            kvalitetskontrollerte data for en lang rekke måleparametere fra NVEs
            Hydra II database, i tillegg til data fra MET, Bane NOR, SMHI, SVV
            og andre aktører.
          </p>

          <p>
            Fordi hensikten med Seriekart er å gi tilgang til
            kvalitetskontrollerte tidsserier, inneholder applikasjonen ikke
            sanntidsdata. Disse finner du i stedet for i
            <a href="http://sildre.nve.no">http://sildre.nve.no</a>.
          </p>

          <p>
            <a href="mailto:nve@nve.no">
              Send oss gjerne en epost </a
            >dersom du har spørsmål eller forslag.
          </p>

          <p></p>

          <h2 class="mb-4">Brukerveiledning</h2>
          <h3>Oversikt</h3>
          <p>
            Illustrasjonen under gir en oversikt over den mest essensielle
            funksjonaliteten i brukergrensesnittet til Seriekart.
          </p>
          <img
            alt="Bruksanvisning"
            width="1000px"
            src="../assets/img/About.png"
            class="mb-5"
          />
          <p></p>
          <h3>Filtrering av tidsserier</h3>
          <p>
            I venstre kolonne finner du funksjoner for filtrering av tidsserier.
            Du kan sortere data ut fra måleparameter, målested, tidsrom,
            feltparametere og en lang rekke andre kriterier. Tidsseriene hentes
            fra NVEs Hydra II database. I tillegg er det mulig å få tilgang til
            tidsserier fra MET, Bane NOR, SMHI, SVV og andre aktører.
          </p>
          <h3>Datakvalitet</h3>
          <p>
            Tidsseriene fra Hydra II databasen hentes fra arkiver med
            kvalitetskontrollerte data. For hver måleparameter finner du
            informasjon om hvilket arkiv data hentes fra og hvordan data har
            blitt kontrollert. For parameteren vannføring, har du i tillegg
            mulighet for å sette grenser for hvor stor andel korrigerte og
            manglende data du vil akseptere, innenfor hele år eller avgrensede
            sesonger.
          </p>
          <img
            alt="Bruksanvisning"
            width="1100px"
            src="../assets/img/AboutDataQuality.png"
            class="mb-5"
          />
          <h3>Metadata</h3>
          <p>
            Når du velger en bestemt tidsserie, får du opp en tabell som
            beskriver metadata knyttet til serien og nedbørsfeltet (for
            måleparametere som har definert nedbørsfelt). For parameteren
            vannføring får du også informasjon om kvalitet av vannføringskurven
            og angivelse av fysiske forhold for vannstandsregistrering og
            vannføringsmåling på målestasjonen.
          </p>
          <img
            alt="Bruksanvisning"
            width="800px"
            src="../assets/img/AboutMetadata.png"
            class="mb-5"
          />
          <h3>Dataeksport</h3>
          <p>
            Du kan eksportere informasjon om valgte tidsserier enten i form av
            metadata eller døgnverdier av selve seriene. Du kan velge å
            eksportere enten en bestemt tidsserie eller et utvalg av serier,
            valgt ut fra geografisk avgrensing eller utplukk i tabell. Data blir
            eksportert i Excel-format.
          </p>
          <img
            alt="Bruksanvisning"
            width="1000px"
            src="../assets/img/AboutExport1.png"
            class="mb-5"
          />
          <img
            alt="Bruksanvisning"
            width="1000px"
            src="../assets/img/AboutExport2.png"
            class="mb-5"
          />
        </section>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "About",
  data: () => {
    return {
      aboutText:
        "NVE Seriekart hjelper deg å finne hydrologiske tidsserier som egner seg for bruk i analyser og lignende. Løsningen lar deg filtrere tidsserier basert på en rekke ulike egenskaper. Du kan også eksportere ut metadata og døgnverdier for tidsseriene.",
      sections: [
        {
          title: "Filtrering av tidsserier",
          text:
            "Nulla felis urna, fermentum sit amet egestas ut, mollis eu lectus. Sed ultricies, nisl non vulputate hendrerit, urna elit convallis diam, vitae mattis dui arcu nec dolor. Integer diam metus, condimentum in nibh a, rhoncus iaculis leo. Praesent maximus rutrum sapien ut placerat. In vel sem ut eros placerat venenatis. Aenean efficitur, mauris ut auctor facilisis, quam sem tempor ligula, non luctus augue dui sit amet nibh. Integer iaculis condimentum mollis. Curabitur tincidunt, ex vitae pellentesque pretium, neque erat consectetur sapien, at convallis nisi sem non velit. Sed a nisi cursus, elementum dui ac, consequat ipsum. Cras vel ligula vitae tellus commodo varius. Phasellus quis eros vel arcu accumsan sollicitudin. Morbi eleifend blandit neque eget tempor. Vestibulum eu consequat lacus. Nullam sodales in ligula et molestie. Nam quis ligula feugiat, molestie dui imperdiet, accumsan purus.",
        },
      ],
    };
  },
};
</script>

<style>
.aboutContainer {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding-bottom: 50px;
}
.aboutContainer section {
  width: 80%;
}
.aboutContainer h2 {
  margin-top: 20px;
}
.aboutContainer section ul {
  list-style: none;
}
.listSpacing li {
  margin-top: 5px;
}
#main-content section p {
  margin-left: 10px;
  margin-bottom: 7px;
}
#otherSolutions {
  display: flex;
  flex-wrap: wrap;
}
.solution {
  width: 200px;
  margin: 20px;
}

.about-header {
  position: relative;
}
.about-header span {
  position: absolute;
  top: -70px;
}
</style>
